import firebase from "../../firebase";

async function getInfo(categorie){
    let docRefPs4 = await firebase.db.collection("ps4").where("categorie", "==", categorie).get();
    let docRefPs5 = await firebase.db.collection("ps5").where("categorie", "==", categorie).get();
    let docRefSwitch = await firebase.db.collection("switch").where("categorie", "==", categorie).get();
 
    let dataPs4 =  docRefPs4.docs.map(doc =>{
        return {
            id: doc.id,
            ...doc.data()
        }
    })
    let dataPs5 = docRefPs5.docs.map(doc =>{
        return {
            id: doc.id,
            ...doc.data()
        }
    })
    let dataSwitch = docRefSwitch.docs.map(doc =>{
        return {
            id: doc.id,
            ...doc.data()
        }
    });
    
    dataPs4 = dataPs4.concat(dataPs5).concat(dataSwitch);
    
    return dataPs4;
}

export const getGamesAction = () => {
    return getInfo("action");
}

export const getGamesSport = () => {
    return getInfo("sport");
}

export const getGamesTerror = () => {
   return getInfo("terror");
}

export const getGamesAdventure = () => {
    return getInfo("adventure");
}